export default {"src":"/_next/static/media/advantages-icon-3.d4b216a4.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};